import styled from 'styled-components';

const StyledItineraryBlockCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 492px;
  max-width: 75vw;
  scroll-snap-align: start;
  scroll-snap-align: center;
  overflow: hidden;
`;

const StyledItineraryBlockCardHeader = styled.div`
  color: ${(props) => props.theme.color.white};
  background-color: ${(props) => props.theme.color.primary};
  padding: 20px 50px;
  border-top-right-radius: 7px;
  border-top-left-radius: 7px;
`;

const StyledItineraryBlockCardHeaderTitle = styled.h4`
  color: ${(props) => props.theme.color.white};
  font-weight: 700;
`;
const StyledItineraryBlockBody = styled.div`
  padding: 0px 20px;
  background-color: ${(props) => props.theme.offWhite};
  border-left: 1px solid ${(props) => props.theme.color.borderColor};
  border-right: 1px solid ${(props) => props.theme.color.borderColor};
  border-bottom: 1px solid ${(props) => props.theme.color.borderColor};
  border-bottom-right-radius: 7px;
  border-bottom-right-radius: 7px;
`;

export {
  StyledItineraryBlockCardWrapper,
  StyledItineraryBlockCardHeader,
  StyledItineraryBlockBody,
  StyledItineraryBlockCardHeaderTitle,
};
